import React from 'react';

import LogOutLink from 'common/components/LogOutLink';
import { trackLogOutLink } from '../tracking';
import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from '../messages';

export default class AVLogOutLink extends React.Component {
  render() {
    return (
      <p className="logout">
        <LogOutLink onClick={trackLogOutLink} className="uppercase text--small">
          <TranslatedMessage id={m.LOGOUT} />
        </LogOutLink>
      </p>
    );
  }
}
